var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerNuclearUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1E124A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252-120q-54.69 0-93.34-38.72Q120-197.44 120-252.22t38.72-93.28q38.72-38.5 93.5-38.5t93.28 38.66Q384-306.69 384-252q0 23.05-7.5 44.52Q369-186 355-169v-27q29 14 61 21t64 7q130 0 221-91t91-221h72q0 79.38-30 149.19T751.5-208.5Q699-156 629.5-126T479.59-96Q436-96 393.5-106T312-135q-14 8-29.19 11.5Q267.62-120 252-120Zm0-73q24.58 0 41.79-17.21T311-252q0-24.58-17.21-41.79T252-311q-24.58 0-41.79 17.21T193-252q0 24.58 17.21 41.79T252-193Zm227.78-155q-54.78 0-93.28-38.72t-38.5-93.5q0-54.78 38.72-93.28t93.5-38.5q54.78 0 93.28 38.72t38.5 93.5q0 54.78-38.72 93.28t-93.5 38.5ZM96-480q0-80 30-149.5t82.5-122Q261-804 330.81-834T480-864q44.31 0 86.66 10Q609-844 648-825q14-8 29.19-11.5Q692.38-840 708-840q54.69 0 93.34 38.72Q840-762.56 840-707.78t-38.72 93.28q-38.72 38.5-93.5 38.5t-93.28-38.66Q576-653.31 576-708q0-23.05 7.5-44.52Q591-774 605-791v27q-29-14-61-21t-64-7q-130 0-221 91t-91 221H96Zm612-169q24.58 0 41.79-17.21T767-708q0-24.58-17.21-41.79T708-767q-24.58 0-41.79 17.21T649-708q0 24.58 17.21 41.79T708-649ZM252-252Zm456-456Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerNuclearUnitIcon);
export default __webpack_public_path__ + "static/media/marker-nuclearUnit-icon.46ca5e954900bb2c31ba13c11ed5a897.svg";
export { ForwardRef as ReactComponent };